export const camelize = (modalName: string, firstLetterUppercase = false): string => {
  return modalName
    .split('_')
    .map((word, index) => {
      if (firstLetterUppercase || index > 0) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word.toLowerCase();
    })
    .join('');
};
